import * as S from './TodayBtns.styled';
import { MenuItem } from 'components';
import PropTypes from 'prop-types';

const menuItems = [
  { id: 'Today', label: 'Today' },
  { id: 'Yesterday', label: 'Yesterday' },
  { id: 'This Week', label: 'This Week' },
  { id: 'This Month', label: 'This Month' },
  { id: 'Last 7 Days', label: 'Last 7 Days' },
  { id: 'Last 14 Days', label: 'Last 14 Days' },
  { id: 'Last Month', label: 'Last 30 Days' },
  { id: 'Last Full Month', label: 'Last Month' },
];

export const casesForTypes = menuItems.map((menuItem) => menuItem.id);

export const TodayBtns = ({ typeOfOnChange$, typeOfCalendar$ }) => {
  const clickTodayBtn = (e) => {
    const menuItem = e.target.closest('li');
    if (!menuItem || !menuItem.id) {
      e.stopPropagation();
      return;
    }

    typeOfOnChange$.value = menuItem.id;
  };

  return (
    <S.TodayBtnList onClick={clickTodayBtn}>
      {menuItems.map((item) => (
        <MenuItem
          isSelected={typeOfCalendar$.value === item.id}
          height={32}
          width={113}
          value={item.id}
          id={item.id}
          onClick={() => {}}
          key={item.id}
        >
          {item.label}
        </MenuItem>
      ))}
    </S.TodayBtnList>
  );
};

TodayBtns.propTypes = {
  typeOfOnChange$: PropTypes.shape({
    value: PropTypes.oneOf([...casesForTypes, 'Custom']),
  }).isRequired,
  typeOfCalendar$: PropTypes.shape({
    value: PropTypes.oneOf([...casesForTypes, 'Custom']),
  }).isRequired,
};
